import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

type Currency = 'COP' | 'USD' | 'EUR';

interface CurrencyContextType {
  currency: Currency;
  setCurrency: (c: Currency) => void;
  toggleCurrency: () => void;
}

const CurrencyContext = createContext<CurrencyContextType>({
  currency: 'COP',
  setCurrency: () => {},
  toggleCurrency: () => {},
});

export function CurrencyProvider({ children }: { children: ReactNode }) {
  const [currency, setCurrency] = useState<Currency>(() => {
    try {
      const saved = localStorage.getItem('preferred_currency');
      if (saved === 'USD' || saved === 'COP' || saved === 'EUR') return saved;
    } catch {
      // Ignorar errores de localStorage (ej: modo incógnito)
    }
    return 'COP';
  });

  useEffect(() => {
    try {
      localStorage.setItem('preferred_currency', currency);
    } catch {
      // Ignorar errores de localStorage (ej: modo incógnito)
    }
  }, [currency]);

  const toggleCurrency = () => {
    setCurrency(prev => {
      if (prev === 'COP') return 'USD';
      if (prev === 'USD') return 'EUR';
      return 'COP';
    });
  };

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, toggleCurrency }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyContext);
